import React, { ReactElement } from 'react';

export interface ImageProps {
  alt: string;
  className?: string;
  src: string;
}

export function Image({ alt, className, src }: ImageProps): ReactElement {
  return <img alt={alt} className={className} src={src} />;
}
